module.exports = new __parcel__URL__("insight-object-view-header-skeleton.tpl.16b423cc.svg").toString();